<!--
 * @Author: your name
 * @Date: 2021-04-21 09:37:58
 * @LastEditTime: 2021-05-12 10:30:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/custom/sealApproval/list.vue
-->
<template>
  <div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSubmit" style="width:200px;" v-model="formInline.fileQueryString" placeholder="合同附件编号/名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSubmit" style="width:200px;" v-model="formInline.contractQueryString" placeholder="商务合同编号/名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSubmit" style="width:200px;" v-model="formInline.sealApplyUserName" placeholder="盖章申请人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSubmit" style="width:200px;" v-model="formInline.sealOperatorName" placeholder="盖章经办人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜 索</el-button>
      </el-form-item>
    </el-form>
    <div class="btn-text—flex">
      <div class="table-count">{{sealType==='0'?'待':'已'}}审批合同总数：{{total}}条</div>
      <div>
        <el-badge v-if="type === 'ExamineProcessing'" style="margin:0 25px;" :value="multiSelectList.length" class="item">
          <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="openDialog">批量审批</el-button>
        </el-badge>
      </div>
    </div>
    <el-table size="small" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection"  width="55" align="center"></el-table-column>
      <el-table-column align="center" prop="code" label="合同附件编号"></el-table-column>
      <el-table-column align="center" prop="name" label="合同附件">
        <template slot-scope="scope">
          <filePreview :fileList="scope.row.fileList"></filePreview>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="address" label="盖章类型">
        <template slot-scope="scope">
          {{sealTypeStatus[scope.row.sealType]}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="sealOperatorName" label="盖章经办人"></el-table-column>
      <el-table-column align="center" prop="contractName" label="所属商务合同"></el-table-column>
      <el-table-column align="center" prop="sealApplyUserName" label="盖章申请人"></el-table-column>
      <el-table-column align="center" prop="sealApplyTime" label="盖章申请时间"></el-table-column>
      <el-table-column align="center" prop="name" label="盖章状态">
        <template slot-scope="scope">
          {{sealStatus[scope.row.sealStatus]}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="address" label="操作">
        <template slot-scope="scope">
          <el-button size="small" v-if="sealType === '0'" type="text" @click="examinationClick(scope.row.id)">审批</el-button>
          <el-button size="small" v-else type="text" @click="detailsClick(scope.row.id)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="block" style="text-align:right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <contractDetails @close="closeClick" :dialogTableVisible="dialogTableVisible" :detailsId="detailsId"></contractDetails>
    <el-dialog :title="dialogTitle" width="30%" :visible.sync="dialogTableVisible1">
      <el-form v-if="dialogTitle==='批量审批'" label-position="left" :model="assessForm" ref="assessForm" label-width="100px" class="demo-ruleform">
        <el-form-item label="审批状态" prop="status" class="block-form-item w-99">
          <el-select v-model="assessForm.status" @change="statusChange">
            <el-option label="审批通过" value=1></el-option>
            <el-option label="审批不通过" value=0></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="assessForm.status == 0" label="原因" prop="notPassReason" class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="assessForm.notPassReason"></el-input>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="batchClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisible1 = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { processSealpage, assessSealBatch } from "./api";
import contractDetails from "@/components/common/contractAttachmentDetails"
export default {
  components: {
    contractDetails,
  },
  props:['sealType'],
  data() {
    return {
      sealTypeStatus:['不盖章','公章','合同章'],
      sealStatus:['不盖章','待申请盖章','盖章审核中','盖章审核不通过','待盖章','已盖章','已作废'],
      dialogTableVisible:false,
      detailsId:"",
      formInline:{
        auditFlag:this.sealType,//审批标志（0-待审批/1-已审批）
        contractQueryString:"",
        fileQueryString:"",
        sealApplyUserName:"",
        sealOperatorName:"",
        pageNum: 1,
        pageSize: 10,
      },
      total:0,
      tableData: [],
      multiSelectList:[],
      dialogTableVisible1:false,
      dialogTitle:"",
      //审批
      assessForm: {
        ids:[] ,
        status: "1",
        notPassReason: "",
        auditRemark: "",
      },
    };
  },
  mounted() {
    this.getDataInit()
  },
  methods: {
    getDataInit(){
      processSealpage(this.formInline).then(res=>{
        console.log('=====数据======',res)
        if(res.code === 1){
          this.tableData = res.data
          this.total = res.total
        }
      })
    },
    //跳转审批页面
    examinationClick(id){
      let router = this.$router.push({
        path: "/check/examination",
        query: {id},
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    closeClick(){
      this.dialogTableVisible = false;
    },
    //详情
    detailsClick(id){
      this.detailsId = id;
      this.dialogTableVisible = true;
    },
    //查询
    onSubmit(){
      this.formInline.pageNum = 1;
      this.getDataInit()
    },
    handleSizeChange(val){
      this.formInline.pageSize = val;
      this.getDataInit()
    },
    handleCurrentChange(val){
      this.formInline.pageNum = val;
      this.getDataInit()
    },
    //选择
    handleSelectionChange(val){
      this.multiSelectList = val;
    },

    //打开调整输入框
    openDialog(obj){
      this.dialogTitle = '批量审批' ;
      this.dialogTableVisible1 = true ;
      console.log("======"+obj);
    },

    //批量审批
    batchClick(){
      console.log(this.multiSelectList) ;
      var ids = []
      this.multiSelectList.forEach(element => {
        ids.push(element.id)
      });
      this.assessForm.ids = ids ;
      console.log(ids) ;
      let obj = {};
      obj.ids = ids;
      obj.isPass = parseInt(this.assessForm.status);
      obj.notPassReason = this.assessForm.notPassReason; //审批失败原因
      obj.auditRemark = this.assessForm.auditRemark;
      assessSealBatch(obj)
        .then((res) => {
            this.$message.success("审批成功");
            this.dialogTableVisible1 = false
            this.getList();
        })
        .catch((error) => {
          this.dialogTableVisible1 = false
        });
    },

    //审批状态改变
    statusChange(val) {
      this.assessForm.notPassReason = "";
    },
  },
};
</script>
<style scoped>
.header_dialog{
    display: flex;
    justify-content: space-between;
}
.header_dialog div{
    padding-bottom:10px;
    font-size: 15px;
}
.paddingBtm div{
    padding-bottom:10px;
    font-size: 15px;
}
.chaochu{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-text—flex{
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>